import { useState, useEffect } from "react";
import { RESIZE_TEXT } from "../GlobalConstant";

function useResponsive(breakpoint = 768) {
  const [isMobileDevice, setIsMobile] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };

    window.addEventListener(RESIZE_TEXT, handleResize);

    return () => window.removeEventListener(RESIZE_TEXT, handleResize);
  }, [breakpoint]);

  return {isMobileDevice};
}

export default useResponsive;